export const Text = ({ maxLength, minLength }) => <h1>TextOptions</h1>
